import React, { useMemo, useState } from "react";
import { useViewport } from 'components/general/useViewPort'
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import { isStartListStatus } from "helpers/status";

import { TableColumns as Columns} from 'components/sports/glf/individual/playoff/Columns'
import { TableExpanded } from 'components/sports/glf/individual/playoff/TableExpanded'


const getConfiguration = (data) => {
    const columnsAdded = [];
    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;

    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartListStatus(resultStatus),
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    configuration.caption = <CaptionTable
        leftCol={<h3 className="text-dark">{data && data?.results?.eventUnit?.description}</h3>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = [{ id: 'Rank', desc: false }]

    configuration.columns = Columns(data)

    return configuration;
};

const PlayOff = ({ data }) => {
    const { breakPoint } = useViewport();
    const rsc = data?.results?.eventUnitCode
    const resultStatus = data?.results?.status?.code
    const extendedInfos = data.results?.extendedInfos
    const config = useMemo(() => getConfiguration(data, breakPoint), [breakPoint]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
              <TableExpanded row={row?.original} unitData={data}/>
         }/>
          // eslint-disable-next-line
      ), [extendedInfos, resultStatus, breakPoint]);

    let hiddenColumns = []

    return (
    <>
        {data?.results
            ? (
                <>
                    < MirsTable
                        className="mb-3"
                        //Dato to show by row
                        data={data.results.items}
                        //Columnas a visualizar 
                        columns={config.columns}
                        //subcomponente a renderizar, extended
                        renderRowSubComponent={renderRowSubComponent}
                        //Key by row necesary in order to no paint innecesary
                        keyRow='participant-code'
                        //Component caption
                        caption={config.caption}
                        //Columns to hidde 
                        hiddenColumns={hiddenColumns}
                        //When show table is sorted by 
                        initialSortBy={config.sortBy}
                        id={`mirs-table-po-${rsc}`}
                    />
                </>
            ) : ''
        }
    </>
    )
}

export default PlayOff;